import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "steps" }
const _hoisted_2 = {
  key: 0,
  class: "step__basic"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите владельца средства размещения информации ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Пример: ООО \"АгроТехПромСервис\"", -1)
const _hoisted_6 = {
  key: 1,
  class: "step__basic"
}
const _hoisted_7 = { class: "left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите тип информации", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите, чтобы выбрать тип конструкции из списка", -1)
const _hoisted_10 = { style: {"width":"200px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Количество сторон", -1)
const _hoisted_12 = { style: {"width":"200px","margin-top":"-75px","margin-left":"280px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Количество элементов", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Размер", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Введите значение текстом, в мм. Пример: 2 х 2 мм", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Текст", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "blueSpan" }, "Введите отображаемый текст. Пример: вывеска \"Магнит\"", -1)
const _hoisted_18 = { class: "right" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Технологическая характеристика", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Внутренний подсвет, отсутствует, другое", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 1}),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subpage = 1))
      }, "Шаг 1", 2),
      _createElementVNode("button", {
        class: _normalizeClass({activeStep: _ctx.subpage == 2}),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.subpage = 2))
      }, "Шаг 2", 2)
    ]),
    (_ctx.subpage == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите название",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.information_owner) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.information_owner]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.subpage == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.construction_type_title,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.construction_type_title) = $event)),
                editable: "",
                options: _ctx.construction_type_options,
                optionLabel: "name",
                placeholder: _ctx.construction_type_default.name,
                style: {"width":"480px"},
                onChange: _ctx.construction_type_change
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    style: {"width":"199px"},
                    class: "input",
                    placeholder: "2",
                    type: "number",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.number_sides) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.document.number_sides]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    style: {"width":"199px"},
                    class: "input",
                    placeholder: "4",
                    type: "number",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.number_elements) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.document.number_elements]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_14,
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите размер",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.document.size) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.size]
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_16,
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Введите текст",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.document.information_text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.document.information_text]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, [
              _hoisted_19,
              _hoisted_20,
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.technological_characteristic_title,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.technological_characteristic_title) = $event)),
                editable: "",
                options: _ctx.technological_characteristic_options,
                optionLabel: "name",
                placeholder: _ctx.technological_characteristic_default.name,
                style: {"width":"480px"},
                onChange: _ctx.technological_characteristic_change
              }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
              (_ctx.document.technological_characteristic != 'Внутренний подсвет' && _ctx.document.technological_characteristic != 'Отсутствует')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    class: "input",
                    type: "text",
                    placeholder: "Введите технологическую характеристику",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.document.technological_characteristic) = $event))
                  }, null, 512)), [
                    [_vModelText, _ctx.document.technological_characteristic]
                  ])
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}